const $inject = [];
const lbaDate = function () {
  return {
    restrict: 'A',
    scope:{
      saveTo: '=saveTo',
      slice: '=slice',
      index: '=index',
      lookUp: '=lookUp',
      settings: '=settings'
    },
    bindToController: true,
    controller: 'lbaDateCtrl',
    controllerAs: 'vm',
    template: require('./lbaDate.html')
  }
};

lbaDate.$inject = $inject;

export default lbaDate;



// WEBPACK FOOTER //
// ./src/components/lbaDate/lbaDateDir.js